import styled from '@emotion/styled';

type Props = {
  isOpen: boolean;
  zIndex?: number;
};

export const StyledOverlay = styled('div', {
  shouldForwardProp: (prop) => !['isOpen', 'zIndex'].includes(prop),
})<Props>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: ${(props) => props.zIndex ?? 1000};
  transition:
    opacity 0.3s ease-in-out,
    visibility 0.3s ease-in-out;
  opacity: ${(props) => (props.isOpen ? 1 : 0)};
  visibility: ${(props) => (props.isOpen ? 'visible' : 'hidden')};
  display: flex;
  justify-content: center;
  align-items: center;
`;
